{
    "type": {
        "daily_sales": "Ventas diarias",
        "discounts_report": "Descuentos",
        "events_report": "Eventos",
        "general_subscriptions": "General de abonos",
        "sales_commissions": "Comisiones de comerciales",
        "session_closure": "Cierre de sesión",
        "session_expired": "Sesión agotada",
        "settlements": "Liquidaciones",
        "sold_subscriptions": "Abonos vendidos",
        "valuation_history": "Valoraciones"
    }
}
